import { gql } from 'graphql-request';
import {
  NewFinStatusReasonTagCreatedAt,
  NewFinStatusReasonTagID,
  NewFinStatusReasonTagName,
  NewFinStatusReasonTagUUID,
  NewFinStatusReasonTagUpdatedAt
} from '../newFinStatusReasonTagsTypes';

export interface FetchNewFinStatusReasonTagsQueryResponse {
  id: NewFinStatusReasonTagID;
  uuid: NewFinStatusReasonTagUUID;
  createdAt: NewFinStatusReasonTagCreatedAt;
  updatedAt: NewFinStatusReasonTagUpdatedAt;
  name: NewFinStatusReasonTagName;
}

export const FETCH_NEW_FIN_STATUS_REASON_TAGS_QUERY = gql`
  query NewFinStatusReasonTags(
    $filters: NewFinStatusReasonTagsFilters
    $sort: [NewFinStatusReasonTagsSortEnum!]
    $offset: Int
    $limit: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    newFinStatusReasonTags(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        createdAt
        updatedAt
        name
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
